var map = {
	"./borrador.svg": 33763,
	"./carpeta.svg": 51371,
	"./carpeta0.svg": 20312,
	"./carpetako.svg": 5624,
	"./carpetaok.svg": 25960,
	"./en trámite.svg": 98912,
	"./entregado.svg": 18746,
	"./pen. retirada.svg": 35371,
	"./pendente retirada.svg": 93373,
	"./pendiente retirada.svg": 33191,
	"./presentado.svg": 85128,
	"./retenido.svg": 86310,
	"./retido.svg": 22682,
	"./retirado.svg": 6261,
	"./tramitado.svg": 5671
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 63880;